export const CHECKOUT_BASIC =
  'https://mega-pack-electronica-para-emprender.impultienda.ar/checkout'
export const CHECKOUT_PREMIUM =
  'https://mega-pack-electronica-para-emprender.impultienda.ar/checkout'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/vXUjGhvSnLyikNAG1Lwtb1/Imagen_de_Codex_28_ago_2026,_17_04_35.png'

export const heroBullets = [
  '6 Tomos completos',
  '6 Bonos estratégicos',
  'Proyectos y recursos prácticos',
  'Enfoque emprendedor',
  'Ideal para emprendedores, técnicos y docentes',
  'Material 100% digital — acceso inmediato',
]

export const proofStats = [
  { value: '6', label: 'Tomos completos' },
  { value: '6', label: 'Bonos incluidos' },
  { value: '100%', label: 'Material digital y práctico' },
  { value: '24 h', label: 'Aprendé a tu ritmo, cuando quieras' },
]

export const testimonials = [
  {
    quote: 'Me ayudó a ordenar todo y empezar a practicar de verdad.',
    author: 'Carlos M.',
    location: 'Córdoba',
  },
  {
    quote: 'Los proyectos son claros y fáciles de seguir. Muy buen material.',
    author: 'Diego R.',
    location: 'Rosario',
  },
  {
    quote: 'Encontré muchísimo contenido que puedo adaptar para mis clases.',
    author: 'Marcelo G.',
    location: 'Buenos Aires',
  },
  {
    quote: 'Pasé de mirar tutoriales sueltos a tener una guía para avanzar.',
    author: 'Lucas P.',
    location: 'Mendoza',
  },
  {
    quote:
      'Me dio ideas concretas para empezar a aplicar la Electrónica en proyectos.',
    author: 'Fernando S.',
    location: 'La Plata',
  },
]

export const TESTIMONIALS_NOTE =
  'Ejemplos de maquetación: reemplazar por testimonios, nombres y ubicaciones reales antes de publicar.'

export const shortTestimonials = [
  {
    quote: 'Ahora entiendo mucho mejor los circuitos y cómo llevarlos a la práctica.',
    author: 'Martín R.',
  },
  {
    quote: 'Está todo ordenado. Dejé de perder horas buscando tutoriales.',
    author: 'Diego M.',
  },
  {
    quote: 'Los proyectos me ayudaron a pasar de la teoría a la práctica.',
    author: 'Pablo G.',
  },
  {
    quote: 'Como docente, me simplificó muchísimo la preparación del material.',
    author: 'Alejandro C.',
  },
]

export const painPoints = [
  'Mirás videos durante horas, pero nunca sabés por dónde empezar.',
  'Descargás PDFs, diagramas y tutoriales que terminan perdidos en alguna carpeta.',
  'Tenés conocimientos básicos, pero no sabés cómo llevarlos a proyectos concretos.',
  'Comprás componentes y después no sabés qué construir con ellos.',
  'Empezás proyectos que terminan quedando a mitad de camino.',
  'Querés mejorar profesionalmente, pero la información está desordenada.',
  'Sos docente y perdés horas buscando material para preparar tus clases.',
  'Querés emprender con Electrónica, pero no sabés cómo transformar lo que sabés en algo que alguien pague.',
]

export const objections = [
  'Desordenada',
  'Separada en cientos de videos',
  'Explicada sin una ruta clara',
  'Demasiado teórica',
  'Sin aplicación práctica',
  'Sin orientación para emprender',
]

export const audience = [
  'Personas que quieren aprender Electrónica',
  'Emprendedores que buscan una nueva habilidad',
  'Técnicos y profesionales que quieren ampliar conocimientos',
  'Docentes que necesitan material organizado',
  'Quienes quieren transformar la Electrónica en productos o servicios',
]

export const pillars = [
  {
    title: 'Aprender',
    desc: 'Entendé los conceptos y componentes necesarios sin perderte entre información innecesaria.',
  },
  {
    title: 'Hacer',
    desc: 'Pasá de la teoría a circuitos, prácticas y proyectos concretos.',
  },
  {
    title: 'Emprender',
    desc: 'Detectá maneras de usar esos conocimientos para crear productos, ofrecer servicios y desarrollar oportunidades.',
  },
]

export const results = [
  'Organizar tu aprendizaje',
  'Entender los fundamentos de Electrónica',
  'Reconocer y utilizar componentes',
  'Comprender circuitos',
  'Llevar la teoría a la práctica',
  'Desarrollar proyectos',
  'Tener material de consulta siempre a mano',
  'Ahorrar horas buscando información dispersa',
  'Usar los recursos como apoyo profesional',
  'Adaptar el material para tus clases',
  'Explorar cómo emprender con Electrónica',
]

export const tomos = [
  {
    title: 'Fundamentos de Electrónica',
    lead: 'Empezá construyendo una base sólida.',
    desc: 'Desde las bases de electricidad y Electrónica hasta los principios que necesitás dominar antes de meterte en proyectos complejos. Ideal para empezar de cero o reforzar.',
  },
  {
    title: 'Componentes y Mediciones',
    lead: 'Dejá de ver componentes sin saber qué hacen.',
    desc: 'Resistencias, capacitores, diodos, transistores, sensores y semiconductores. Más conceptos de medición y diagnóstico que vas a necesitar en tus proyectos.',
  },
  {
    title: 'Circuitos y Práctica',
    lead: 'Pasá de entender componentes a entender sistemas.',
    desc: 'Cómo se relacionan los componentes dentro de un circuito y cómo llevar los conceptos a ejercicios y aplicaciones prácticas. Porque la Electrónica se aprende construyendo.',
  },
  {
    title: 'Proyectos Electrónicos',
    lead: 'Transformá conocimientos en cosas que funcionan.',
    desc: 'Conocimiento → circuito → proyecto. Cada proyecto te da más confianza y nuevas habilidades prácticas.',
  },
  {
    title: 'Reparación y Diagnóstico',
    lead: 'Aprendé a pensar como quien resuelve problemas.',
    desc: 'Detectar fallas, realizar mediciones, analizar circuitos, comprender problemas frecuentes y seguir procesos de diagnóstico ordenados.',
  },
  {
    title: 'Electrónica para Emprender',
    lead: 'Dejá de pensar solo como estudiante.',
    desc: 'Servicios, reparaciones, productos, proyectos personalizados, capacitación y soluciones electrónicas: cómo convertir una habilidad técnica en oportunidades reales.',
  },
]

export const tomoIncludes = [
  'Contenido organizado paso a paso',
  'Explicaciones prácticas',
  'Material de consulta',
  'Ejemplos',
  'Recursos descargables',
  'Ejercicios y actividades',
  'Aplicaciones prácticas',
  'Orientación para proyectos',
  'Recursos útiles para docentes',
  'Enfoque profesional y emprendedor',
]

export const bonuses = [
  {
    title: 'Guía de Inicio Rápido',
    desc: 'Una hoja de ruta para saber qué estudiar primero, cómo organizar el material y cómo avanzar.',
    value: '$8.000',
  },
  {
    title: 'Banco de Proyectos Electrónicos',
    desc: 'Ideas y proyectos para llevar tus conocimientos a la práctica. Dejá de preguntarte “¿y ahora qué construyo?”.',
    value: '$10.000',
  },
  {
    title: 'Kit de Plantillas Técnicas',
    desc: 'Plantillas para organizar proyectos, componentes, materiales, mediciones y procedimientos.',
    value: '$9.000',
  },
  {
    title: 'Guía de Diagnóstico',
    desc: 'Una guía práctica para desarrollar una mentalidad ordenada al momento de buscar fallas.',
    value: '$8.000',
  },
  {
    title: 'Kit Docente de Electrónica',
    desc: 'Recursos para docentes y capacitadores que quieran usar el material como apoyo en sus clases.',
    value: '$9.000',
  },
  {
    title: 'Guía Emprendedor Electrónico',
    desc: 'Ideas, modelos y orientación para convertir conocimientos de Electrónica en productos o servicios.',
    value: '$9.000',
  },
]

export const comparisonRows = [
  {
    sit: 'Tenés conocimientos',
    sin: 'No sabés cómo aprovecharlos',
    con: 'Tenés una orientación para aplicarlos',
  },
  {
    sit: 'Querés emprender',
    sin: 'No sabés por dónde empezar',
    con: 'Tenés una ruta más clara',
  },
  {
    sit: 'Aparece un proyecto',
    sin: 'Improvisás',
    con: 'Tenés plantillas y recursos',
  },
  {
    sit: 'Querés ofrecer servicios',
    sin: 'Dudás cómo organizarte',
    con: 'Tenés herramientas de apoyo',
  },
  {
    sit: 'Tenés muchas ideas',
    sin: 'Quedan solamente como ideas',
    con: 'Empezás a convertirlas en proyectos',
  },
]

export const faqs = [
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. El material está organizado para que puedas comenzar por los fundamentos y avanzar progresivamente.',
  },
  {
    q: '¿Sirve si ya tengo conocimientos de Electrónica?',
    a: 'Sí. Podés usar los tomos, proyectos y recursos para reforzar conceptos, consultar material y desarrollar nuevas aplicaciones.',
  },
  {
    q: '¿Es solamente para emprendedores?',
    a: 'No. Está pensado para emprendedores, profesionales, técnicos, estudiantes y docentes interesados en Electrónica.',
  },
  {
    q: '¿Sirve para docentes?',
    a: 'Sí. Incluye recursos que pueden usarse como material de apoyo y adaptarse a clases y capacitaciones.',
  },
  {
    q: '¿Voy a ganar dinero automáticamente con esto?',
    a: 'No. CM Digital Pro no promete ingresos automáticos ni resultados garantizados. El Mega Pack te da conocimientos, herramientas, ideas y recursos: los resultados dependen de cómo apliques lo aprendido.',
  },
  {
    q: '¿Cómo recibo el Mega Pack?',
    a: 'El producto es digital. Una vez acreditado el pago recibís las instrucciones correspondientes para acceder al material.',
  },
  {
    q: '¿Puedo estudiar a mi ritmo?',
    a: 'Sí. Podés avanzar de acuerdo con tu experiencia, disponibilidad y objetivos.',
  },
  {
    q: '¿Necesito comprar herramientas o componentes?',
    a: 'Para estudiar gran parte del material, no. Para realizar determinados proyectos prácticos pueden ser necesarios componentes o herramientas específicas.',
  },
  {
    q: '¿Cuánto tiempo tengo que dedicar?',
    a: 'Depende de tu objetivo. Podés avanzar gradualmente y adaptar el aprendizaje al tiempo que tengas disponible.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días de garantía desde tu compra.',
  },
]

export const withoutSystem = [
  'Seguís mirando tutoriales aislados',
  'Guardás PDFs que después nunca encontrás',
  'Aprendés conceptos sin conectarlos',
  'Empezás proyectos y los abandonás',
  'Seguís preguntándote qué estudiar después',
  'Si sos docente, preparás material desde cero',
  'Si querés emprender, esperás “saber un poco más”',
]

export const withSystem = [
  'Tenés una ruta',
  'Tenés material organizado',
  'Tenés recursos y plantillas',
  'Tenés proyectos para practicar',
  'Tenés herramientas de consulta',
  'Tenés contenido para seguir aprendiendo',
  'Tenés un enfoque para pasar a la acción',
]

export const plans = [
  {
    id: 'basic',
    name: 'Mega Pack Electrónica para Emprender',
    audience:
      'Ideal para quienes quieren aprender, practicar y empezar a desarrollar proyectos electrónicos.',
    features: [
      '6 Tomos completos',
      '6 Bonos estratégicos',
      'Material digital',
      'Recursos prácticos',
      'Banco de proyectos',
      'Material para docentes',
      'Guía para emprender',
      'Acceso inmediato',
    ],
    listPrice: '$51.000',
    price: '$19.990',
    href: CHECKOUT_BASIC,
    cta: 'Quiero el Mega Pack completo',
    recommended: false,
  },
  {
    id: 'premium',
    name: 'Mega Pack + Kit Emprendedor Pro',
    audience:
      'Ideal para quienes quieren ir más allá del aprendizaje y convertir sus conocimientos en proyectos y oportunidades.',
    features: [
      'Los 6 Tomos completos',
      'Los 6 Bonos estratégicos',
      'Mega Pack completo',
      'Kit Emprendedor Pro',
      'Plantillas adicionales',
      'Recursos para organizar servicios y proyectos',
      'Material adicional de apoyo profesional',
    ],
    listPrice: '$69.000',
    price: '$27.990',
    href: CHECKOUT_PREMIUM,
    cta: 'Quiero el Mega Pack + Kit Emprendedor Pro',
    recommended: true,
  },
]
